import styled from 'styled-components';

import { vars, media, pxToRem } from '$util/theme';

export const Styled = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  .ForgotPasswordEmailSent {
    box-sizing: border-box;
    width: 80%;
    margin: 0 auto;
    text-align: center;
  }

  .title {
    margin-top: 75px;
    margin-bottom: 20px;

    font-size: ${pxToRem(24)};
    font-weight: ${vars.fontWeight.semiBold};
    line-height: 28px;

    ${media.up('md')} {
      margin-top: 125px;
      margin-bottom: 50px;
      font-size: ${pxToRem(32)};
      font-weight: ${vars.fontWeight.semiBold};
      line-height: 34px;
    }
  }

  .Card {
    box-sizing: border-box;
    gap: 20px;
    max-width: ${pxToRem(500)};
    ${media.down('sm')} {
      width: 100%;
    }
    ${media.up('sm')} {
      min-width: 340px;
    }
    margin-bottom: 120px;

    .forgot-password {
      text-align: right;
    }

    .btn-primary {
      display: block;
      width: 100%;
      margin: 20px auto;
    }
  }

  color: ${vars.quantumverse.reskinColors.neutral700};
  box-shadow: 0px 3px 8px 0px rgba(164, 164, 164, 0.21);
  border-radius: ${vars.defaultBorderRadius};
  font-weight: ${vars.fontWeight.regular};
`;
